module.exports = "img/flags/NI.49391ad.png";